module.exports = __webpack_public_path__ + "img/loginbg.7546bc7d.png";